var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Color, Size } from '../const';
function Label(props) {
    return (React.createElement(StyledLabel, __assign({}, props), props.isRequired ? '必須' : props.children));
}
var StyledLabel = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 2px;\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1;\n  padding: 3px 4px 1px;\n  white-space: nowrap;\n"], ["\n  background: ",
    ";\n  border-radius: 2px;\n  color: ", ";\n  font-size: ", "px;\n  line-height: 1;\n  padding: 3px 4px 1px;\n  white-space: nowrap;\n"])), function (props) {
    return props.isRequired ? Color.SOFT_RED : Color.DARK_GRAY_2;
}, Color.WHITE, Size.FONT.XSMALL);
export default Label;
var templateObject_1;
//# sourceMappingURL=label.js.map